const { PLATFORM_SUPPORT_LANGUAGES } = require('@bfe/by-shared-settings');

const locales = PLATFORM_SUPPORT_LANGUAGES.map((locale) => locale.value);

module.exports = locales;
